import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import WdevPageHero from "./components/WdevPageHero";
import WdevIntroSection from "./components/WdevIntroSection";
import WdevWhyChoose from "./components/WdevWhyChoose";
import WdevProcess from "./components/WdevProcess";
import WdevTechnologies from "./components/WdevTechnologies";
import WdevStats from "./components/WdevStats";
import WdevTestimonials from "./components/WdevTestimonials";
import WdevCtaBanner from "./components/WdevCtaBanner";
import "./web-development.css";

const WebDevelopmentPage: React.FC = () => {
  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <WdevPageHero />
            <WdevIntroSection />
            <WdevWhyChoose />
            <WdevProcess />
            <WdevTechnologies />
            <WdevStats />
            <WdevTestimonials />
            <WdevCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default WebDevelopmentPage;
